import { render, staticRenderFns } from "./SenatiCalidadSenatiATC.vue?vue&type=template&id=f93161b2&"
import script from "./SenatiCalidadSenatiATC.vue?vue&type=script&lang=js&"
export * from "./SenatiCalidadSenatiATC.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports